module.exports = __webpack_public_path__ + "img/ic-contact-line.0e2966e5.png";